import { IElementsProvider } from "./IElementsProvider";
import { Product } from '@/store/modules/product';
import { ElementMenuItem } from '../elementMenuItem';
import { Vector2 } from '@babylonjs/core';
import { ElementType, SpecyficType } from '../element';

class BedsidetableElementsProvider implements IElementsProvider {

    public get(product: Product): ElementMenuItem[] {
        return [
            new ElementMenuItem(
                'ikony_Szuflada_mala.svg',
                'bedsideTableDrawer',
                'sn_s_455_1.gltf',
                '',
                'sn_s_455_1_komora_light.jpg',
                new Vector2(1, 1),
                ElementType.INSIDE,
                SpecyficType.DRAWER,
            ),
        ];
    }
}

export const bedsidetableElementsProvider = new BedsidetableElementsProvider();
